export { getWishlistServerAction } from 'next-flight-server-reference-proxy-loader?id=000a8516632e3409febd0093ceb4341d8a6cf38e14&name=getWishlistServerAction!'